<template>
    <div class="task-box task2" v-if="body_show">
        <div class="task-title">
			{{ title }}
		</div>
        <!--  -->
        <div class="task_f">
			<h3 class="label">你希望通过人物对标，解决什么问题？<span>（参考：职业路径、核心能力、行业认知...）</span></h3>
			<div class="input-mt">
				<textarea  v-model="workvalueone" placeholder="请填写你的对标目标，你想从对标人物身上学到什么"></textarea>
			</div>
			<span class="float">{{workvalueone.length}}/207</span>
		</div>
        <!--  -->
        <div class="task_f">
			<h3 class="label">关于以上这个问题，你从<span class="bt" >&nbsp;{{figure_name}}&nbsp;</span>身上学到了什么？你收获了哪些职业发展的新认知？</h3>
			<div class="input-mt">
				<textarea  v-model="conversine" placeholder="我从对标人物的身上学到了："></textarea>
			</div>
			<span class="float">{{conversine.length}}/207</span>
		</div>
        <p>提示：（可进行修改，直到预览很舒服为⽌）</p>
        <!-- 提交 -->
        <div class="submitBtn">
            <van-button v-if="validationHandle()" @click="submitHandle"  class="actice" >提交</van-button>
            <van-button v-else  >提交</van-button>
        </div>
    </div>
</template>

<script>
import { getStorage, setStorage } from "@/utils/tools"
import { getprototypedata,updateprototypedata } from "@/api/course"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            title:'T3：职业之道',
            figure_name:'88',
            body_show:false,
            workvalueone:'',
            conversine:'',
            objArg: {
                cid: "",
                cpid: "",
                type:'targetreport'
            }
        }
    },
    methods:{
        pullData(){
            getprototypedata({
                cid:this.$route.query.cid,
                type:"taskthree"
            })
            .then(data => {
                this.body_show = true;
                let d = data.data;
                let path =this.$route.path;
                this.figure_name = d.figure_name;
                this.workvalueone = d.workvalueone?d.workvalueone:getStorage(path, 'workvalueone') || '';
                this.conversine = d.conversine?d.conversine:getStorage(path, 'conversine') || '';
            });
        },
        // 验证非空
        validationHandle(){
            if(!this.$Validator.isEmpty(this.workvalueone) && !this.$Validator.isEmpty(this.conversine)){
                return true;
            }
            return false;
        },
        // 提交数据
        submitHandle(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            updateprototypedata({
                cid:this.$route.query.cid,
                type:"taskthree",
                cpid: this.$route.query.pid,
                cptid:this.$route.query.id,
                iscreate: 1,
                workvalueone:this.workvalueone,
                conversine:this.conversine
            })
            .then(data => {
                this.$toast.clear();
                this.objArg.cid = this.$route.query.cid;
                this.objArg.cpid = this.$route.query.pid;
                this.$router.push({path:'/project_report',query:this.objArg});

            });
        },
        setTitle(){
            let title = this.$route.query.name;
            document.title = decodeURI(title);
        }
    },
    created(){
        this.pullData();
        this.setTitle();
        shareCon("course",this);
    },
    watch:{
        workvalueone(newVal,oldVal){
            if(newVal.length > 207) {
              this.workvalueone = newVal.slice(0, 207);
              this.$toast('最多只能输入'+207+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'workvalueone', newVal);
            }
        },
        conversine(newVal,oldVal){
            if(newVal.length > 207) {
              this.conversine = newVal.slice(0, 207);
              this.$toast('最多只能输入'+207+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'conversine', newVal);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@s/taskStyle.scss";
    .task-box{
        .task_f{
            font-size: 32px;
            .label{
                color: #333;
                span{
                    font-size:24px;
                    color: #666;
                }
                span.bt{
                    font-size: 32px;
                    color: #EB5032;
                }
            }
        }
        p{
            font-size:24px;
            color: #666;
        }
    }

</style>
